import React, { useState } from "react";
import { Colors } from "./colors";

const Button = ({ title, func, color, textColor, disable, style }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const linkStyle = {
    margin: "10px",
    width: "100%",
    border: "0",
    background: "none",
    boxShadow: "none",
    borderRadius: "12px",
    fontSize: "14px",
    padding: "8px",
    filter: isHovered ? "brightness(120%)" : "none",
    color: textColor,
    backgroundColor: color,
    cursor: "pointer",
  };
  return (
    <button
      onClick={func}
      style={{ ...linkStyle, ...style }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      disabled={disable}
    >
      {title}
    </button>
  );
};

export default Button;
